import React from 'react'

import { useTranslate } from 'react-admin'

export const DaysTextField = ({ source, record, className }) => {
  const translate = useTranslate()
  return (
    <div className={className}>
      <span>{record[source]}</span>&nbsp;
      <span>
        {parseInt(record[source]) !== 1
          ? translate('resources.creditlines.messages.days')
          : translate('resources.creditlines.messages.day')}
      </span>
    </div>
  )
}
